<template>
  <div>
    <div class="row">
      <div class="col-md-8">
        <h1 class="title-pages">LANÇAMENTOS</h1>
      </div>
      <div class="col-md-4 text-right">
        <!-- <v-btn
          @click="$bvModal.show('filter')"
          class="btn-filter mr-2"
          type="relief"
        >
          <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
        </v-btn> -->
      </div>
    </div>
    <div class="v-clean p-2">
      <b-overlay :show="loading" opacity="0.99">
        <div v-show="data.length == 0" class="v-clean p-5">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <v-data-table
          v-show="data.length > 0"
          dense
          :headers="headers"
          :items="data"
          :footer-props="{
            'items-per-page-options': [25, 50, 75, 100],
            'items-per-page-text': 'Mostrar',
          }"
          :options.sync="options"
          :server-items-length="total"
          :expanded.sync="expanded"
          show-expand
        >
          <template v-slot:[`item.user`]="{ item }">
            {{
              professionalClassCouncilValue({
                id: item.user_professional_class_council_id,
                name: item.user_name,
                profile: item.user_profile_name,
                office: item.user_office,
                cpf: item.user_cpf,
                value: item.user_professional_class_council_value,
              })
            }}
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            {{ moment(item.created_at).format("DD/MM/YYYY HH:mm:ss") }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn small @click="handlePrint(item.id)" class="btn-print"
              ><i class="fas fa-print mr-2 text-twenty"></i>IMPRIMIR</v-btn
            >
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td class="m-0 p-0" :colspan="headers.length">
              <div class="row m-0">
                <div
                  class="col-md-12 pt-0 pb-0 mt-1 mb-1 border"
                  v-for="(resident_account_item, key) in item.items.data"
                  :key="key"
                >
                  <div class="row m-0">
                    <div class="col-md-3 pt-0 pb-0 d-flex align-items-center">
                      <span class="text-muted">TIPO:</span>
                      <strong class="ml-2">{{
                        handleType(resident_account_item.type)
                      }}</strong>
                    </div>
                    <div class="col-md-3 pt-0 pb-0 d-flex align-items-center">
                      <div v-if="resident_account_item.type == 'SERVICE'">
                        <span class="text-muted">QUANTIDADE:</span>
                        <strong class="ml-2">{{
                          resident_account_item.quantity
                        }}</strong>
                      </div>
                      <div v-if="resident_account_item.type == 'STOCK_SALE'">
                        <span class="text-muted">QUANTIDADE:</span>
                        <strong class="ml-2"
                          >{{ resident_account_item.stock_sale_amount }}
                          {{
                            resident_account_item.stock_sale_stock_item_unit_of_measurement_abbreviation
                          }}
                        </strong>
                      </div>
                    </div>
                    <div class="col-md-3 pt-0 pb-0">
                      <span class="text-muted">VALOR:</span>
                      <strong class="ml-2">{{
                        formatReal(resident_account_item.value)
                      }}</strong>
                      <br />
                      <span class="text-muted">TOTAL:</span>
                      <strong class="ml-2">{{
                        formatReal(
                          parseInt(resident_account_item.quantity) *
                            parseFloat(resident_account_item.value)
                        )
                      }}</strong>
                    </div>
                    <div class="col-md-3 pt-0 pb-0 d-flex align-items-center">
                      <span class="text-muted">TOTAL FINAL:</span>
                      <strong class="ml-2">{{
                        formatReal(resident_account_item.total_value)
                      }}</strong>
                    </div>
                    <div
                      class="col-md-12"
                      v-if="resident_account_item.type == 'SERVICE'"
                    >
                      <span class="text-muted">INFORMAÇÕES DO SERVIÇO:</span>
                      <div>
                        <span class="text-muted">SERVIÇO:</span>
                        <strong class="ml-2"
                          >{{ resident_account_item.service_description }}
                        </strong>
                      </div>
                    </div>
                    <div
                      class="col-md-12"
                      v-if="resident_account_item.type == 'STOCK_SALE'"
                    >
                      <span class="text-muted">INFORMAÇÕES DA VENDA:</span>
                      <div>
                        <span class="text-muted">GRUPO:</span>
                        <strong class="ml-2"
                          >{{
                            resident_account_item.stock_sale_stock_group_name
                          }}
                        </strong>
                      </div>
                      <div>
                        <span class="text-muted">MEDICAMENTO:</span>
                        <strong class="ml-2"
                          >{{ resident_account_item.stock_sale_medicine_name }}
                        </strong>
                      </div>
                      <div>
                        <span class="text-muted">LOTE:</span>
                        <strong class="ml-2">{{
                          resident_account_item.stock_sale_lot
                        }}</strong>
                      </div>
                      <div>
                        <span class="text-muted">DATA DE VENCIMENTO:</span>
                        <strong class="ml-2">{{
                          moment(
                            resident_account_item.stock_sale_due_date
                          ).format("MM/YYYY")
                        }}</strong>
                      </div>
                      <div v-if="resident_account_item.stock_sale_description">
                        <span class="text-muted">DESCRIÇÃO:</span>
                        <strong class="ml-2">{{
                          resident_account_item.stock_sale_description
                        }}</strong>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 border-top pt-0 pb-0">
                  <div class="row m-0">
                    <div class="col-md-3"></div>
                    <div class="col-md-3"></div>
                    <div class="col-md-3"></div>
                    <div class="col-md-3">
                      <h1 class="title-pages">
                        <span class="text-muted">TOTAL:</span>
                        {{ formatReal(item.items.total) }}
                      </h1>
                    </div>
                    <div class="col-md-12 text-right">
                      <v-btn
                        small
                        @click="handlePrint(item.id)"
                        class="btn-print"
                        ><i class="fas fa-print mr-2 text-twenty"></i
                        >IMPRIMIR</v-btn
                      >
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </template>
        </v-data-table>
        <ErrorsMessages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";

import api from "../../../../services/api";

import routes from "../../../../routes";

import {
  formatReal,
  formatPrice,
  professionalClassCouncilValue,
} from "../../../../lib/format";

import moment from "moment";

export default {
  name: "ReleaseExecuted",

  components: {
    ErrorsMessages,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      resident_id: "",

      total: 0,
      options: {},

      headers: [
        { text: "QUEM FEZ?", value: "user", sortable: false },
        { text: "DATA", value: "created_at", sortable: false },
        { text: "AÇÕES", value: "actions", sortable: false },
      ],

      expanded: [],

      data: [],

      loading: false,

      errors: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    moment,
    formatReal,
    formatPrice,
    professionalClassCouncilValue,

    handleType(type) {
      return (
        {
          SERVICE: "SERVIÇO",
          STOCK_SALE: "VENDA DA EMPRESA",
        }[type] || "NÃO ENCONTRADO!"
      );
    },

    retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;
    },

    async paginate() {
      try {
        this.loading = true;

        let { resident_id } = this;

        const { page, itemsPerPage } = this.options;

        let params = { resident_id, page, itemsPerPage };

        const response = await api.get("/rest-home/family/releases/executed", {
          params,
        });

        const { error, errors, data, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
          this.total = total;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handlePrint(id) {
      let route = this.$router.resolve({
        name: "family-resident-release",
        params: { id },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>

<style>
.v-data-footer {
  background-color: #fff !important;
}
</style>